module.exports = __webpack_public_path__ + "img/GH-kyujin-top-041.737c1b0a.webp";